"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalSecretsLayerClient = void 0;
const constants_1 = require("../constants");
class LocalSecretsLayerClient {
    constructor() {
        this.extensionHttpPort = process.env.PARAMETERS_SECRETS_EXTENSION_HTTP_PORT || constants_1.LOCAL_CLIENT_DEFAULT_PORT;
        this.sessionToken = process.env.AWS_SESSION_TOKEN || "";
    }
    async fetchSecretValue(secretArn) {
        const secretUrl = `http://localhost:${this.extensionHttpPort}/secretsmanager/get?secretId=${secretArn}`;
        const response = await fetch(secretUrl, {
            headers: {
                [constants_1.AWS_TOKEN_HEADER]: this.sessionToken,
            },
        });
        return response.json();
    }
}
exports.LocalSecretsLayerClient = LocalSecretsLayerClient;
//# sourceMappingURL=LocalSecretsLayerClient.js.map